module.exports = __webpack_public_path__ + "img/1-1P6040T95bI.46f2e008.png";